import { SigLabel } from '../components/atelier';

const ITEMS: Array<{ n: string; title: string; body: string }> = [
  {
    n: '01',
    title: 'Asks before drafting',
    body: 'When the spec is incomplete, the drafter surfaces the right questions before it commits to geometry. Tooth counts. Airfoil families. Sealing methods. Fits and tolerances. It would rather pause than guess and hand you something useless.',
  },
  {
    n: '02',
    title: 'Researches what it doesn’t know',
    body: 'Standards, dimensions, manufacturing techniques. The drafter looks them up at design time rather than relying on whatever its training data happened to remember. Real references, real numbers, real norms.',
  },
  {
    n: '03',
    title: 'Remembers what it learns',
    body: 'Every part it figures out becomes a building block. Assemblies reuse what came before instead of re-discovering it from scratch. The system gets sharper week by week.',
  },
  {
    n: '04',
    title: 'Manufacturing-aware',
    body: 'Wall thicknesses, draft angles, fastener clearances, print orientation, machinable radii. The drafter knows what fabrication wants and refuses to draw what fabrication won’t accept.',
  },
  {
    n: '05',
    title: 'Parametric by default',
    body: 'Every dimension is a named knob, surfaced on the panel the moment the part lands. Drag, type, regenerate. No re-prompting required for size changes.',
  },
  {
    n: '06',
    title: 'STEP, not mesh',
    body: 'Output is real B-rep geometry exported as STEP 214 (and 203). Not a mesh. Not a triangle soup. Actual parametric solids that round-trip into the CAD your team already runs.',
  },
];

export function Persona() {
  return (
    <section className="container section">
      <div className="block-head">
        <div>
          <SigLabel>The drafter</SigLabel>
          <h2>
            An LLM that thinks like a{' '}
            <em>design engineer.</em>
          </h2>
        </div>
        <p className="lede">
          Not text-to-mesh. Not a one-shot generator. A research-and-reasoning
          agent that asks before drafting, looks up what it doesn&rsquo;t
          know, and remembers every part it learns to make.
        </p>
      </div>

      <div className="persona-list">
        {ITEMS.map((it) => (
          <div className="persona-item" key={it.n}>
            <div className="num">{it.n}</div>
            <div>
              <h4>{it.title}</h4>
              <p>{it.body}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
